/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsResume } from "../funcs/agentsResume.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ResumeAgentRequest,
  ResumeAgentSecurity,
} from "../models/operations/resumeagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsResumeMutationVariables = {
  request: ResumeAgentRequest;
  security?: ResumeAgentSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsResumeMutationData = ManagedAgent;

export type AgentsResumeMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * resume agents
 */
export function useAgentsResumeMutation(
  options?: MutationHookOptions<
    AgentsResumeMutationData,
    AgentsResumeMutationError,
    AgentsResumeMutationVariables
  >,
): UseMutationResult<
  AgentsResumeMutationData,
  AgentsResumeMutationError,
  AgentsResumeMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsResumeMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsResume(): MutationKey {
  return ["@gram/client", "agents", "resume"];
}

export function buildAgentsResumeMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsResumeMutationVariables,
  ) => Promise<AgentsResumeMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsResume(),
    mutationFn: function agentsResumeMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsResumeMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsResume(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
